var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search" },
    [
      _c(
        "ui-search",
        {
          directives: [
            {
              name: "focus",
              rawName: "v-focus",
              value: _vm.focus,
              expression: "focus"
            }
          ],
          staticClass: "input",
          class: { focus: _vm.focus },
          on: { enter: _vm.search },
          model: {
            value: _vm.input,
            callback: function($$v) {
              _vm.input = $$v
            },
            expression: "input"
          }
        },
        [
          _c("icon-close", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.input,
                expression: "input"
              }
            ],
            staticClass: "close cl-blue",
            on: {
              click: function($event) {
                return _vm.clear()
              },
              mousedown: function($event) {
                $event.preventDefault()
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }